// AdminOne ONLY — Payout Ledger Page.
import React, { useCallback, useEffect, useState } from "react";
import { SHELL, payoutsApi } from "@/api/connectorPackClient";
import PayoutLedgerCard from "@/components/payouts/PayoutLedgerCard";
import MomoRetryQueue from "@/components/payouts/MomoRetryQueue";

export default function AdminOnePayoutLedgerPage() {
  const [audit,    setAudit]   = useState([]);
  const [lookupId, setLookupId]= useState("");
  const [ledger,   setLedger]  = useState(null);
  const [err,      setErr]     = useState("");

  const load = useCallback(async () => {
    setErr("");
    try { const a = await payoutsApi.audit(); setAudit(a.events || []); }
    catch (e) { setErr(String(e.message || e)); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const lookup = useCallback(async () => {
    if (!lookupId) return;
    setErr("");
    try { const r = await payoutsApi.ledger(lookupId); setLedger(r.settlement || null); }
    catch (e) { setErr(String(e.message || e)); setLedger(null); }
  }, [lookupId]);

  return (
    <div style={SHELL.page} data-testid="adminone-payouts-page">
      <h2 style={SHELL.h2}>AdminOne · Hardening v1 · Mobile Money + Workforce Payouts</h2>
      <h1 style={SHELL.h1}>Payout Ledger</h1>
      <p style={SHELL.dim}>
        AdminOne-only. Disbursements require completed EvidenceOS proof. Telecom maintenance auto-queues retry.
      </p>
      {err && <div style={SHELL.err} data-testid="payouts-err">{err}</div>}
      <div style={SHELL.panel}>
        <h2 style={SHELL.h2}>Settlement Lookup</h2>
        <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
          <input
            type="text"
            placeholder="settlement_id"
            value={lookupId}
            onChange={(e) => setLookupId(e.target.value)}
            style={{ flex: 1, minWidth: 240, background: "rgba(0,0,0,0.4)", border: "1px solid rgba(122,200,96,0.22)", color: "#dfe3eb", padding: "8px 12px", borderRadius: 6, fontSize: 13 }}
            data-testid="payouts-lookup-input"
          />
          <button type="button" style={SHELL.btn(true)} onClick={lookup} data-testid="payouts-lookup-go">Lookup</button>
        </div>
        {ledger && <PayoutLedgerCard ledger={ledger} onChanged={lookup} />}
      </div>
      <MomoRetryQueue audit={audit} />
      <div style={SHELL.panel}>
        <h2 style={SHELL.h2}>Audit · {audit.length} event(s)</h2>
        <table style={SHELL.table}>
          <thead><tr><th style={SHELL.th}>Event</th><th style={SHELL.th}>Channel</th><th style={SHELL.th}>When</th></tr></thead>
          <tbody>
            {audit.map((e) => (
              <tr key={e._id}><td style={SHELL.td}>{e.event_type}</td><td style={SHELL.td}>{e.connector_name}</td><td style={SHELL.td}>{(e.created_at || "").slice(0, 19)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
